/* eslint-disable react-hooks/purity */
import { useMemo, useRef } from "react";
import { logger } from "../lib/logger";

/**
 * Custom hook to provide a Logger instance tied to a component's lifecycle.
 * Generates a unique correlation ID for the component instance.
 */
export function useLogger(prefix = "comp") {
  const correlationIdRef = useRef<string | null>(null);
  if (!correlationIdRef.current) {

    correlationIdRef.current = `${prefix}-${Math.random().toString(36).substring(2, 9)}`;
  }


  return useMemo(() => {
    return logger.withContext(correlationIdRef.current!);
  }, []);
}
